import { render, staticRenderFns } from "./OAuth2Authorize.vue?vue&type=template&id=a187b2b2"
import script from "./OAuth2Authorize.vue?vue&type=script&lang=js"
export * from "./OAuth2Authorize.vue?vue&type=script&lang=js"
import style0 from "./OAuth2Authorize.vue?vue&type=style&index=0&id=a187b2b2&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports